export const decodeJWT = (token: string) => {
  const parts = token.split(".");
  const base64Url = parts.length === 3 ? parts[1] : token;

  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export const encodeJWT = (payload: object): string => {
  const jsonPayload = JSON.stringify(payload);

  const base64 = window.btoa(
    encodeURIComponent(jsonPayload).replace(/%([0-9A-F]{2})/g, (match, p1) => {
      return String.fromCharCode(parseInt(p1, 16));
    })
  );

  const base64Url = base64
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=/g, "");

  return base64Url;
};
